export const MAIN_STORE_NAME = 'main-store';
export const WORKER_STORE_NAME = 'worker-naukar-store';
